import { render, staticRenderFns } from "./stockpurchaseBackAction.vue?vue&type=template&id=0af91588&scoped=true"
import script from "./stockpurchaseBackAction.vue?vue&type=script&lang=js"
export * from "./stockpurchaseBackAction.vue?vue&type=script&lang=js"
import style0 from "./stockpurchaseBackAction.vue?vue&type=style&index=0&id=0af91588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af91588",
  null
  
)

export default component.exports